<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <!-- Breadcrumb Start-->
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Contact Us</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><a href="index.html">Home</a></li>
                                            <li class="text-white active">Contact Us</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Breadcrumb End -->
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Google Map Section Start-->
        <div class="p-0">
            <div class="google-map" style="width:100%;">
                <iframe src="https://maps.google.com/maps?q=laredo&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100" height="300" allowfullscreen></iframe>
            </div>
        </div>
        <!-- Google Map Section End-->
        <!-- Contact Section Start-->
        <section class="section section-contactus contactus-section">
            <div class="container">

                <div class="wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">Contact</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-40">Get in touch with us</h2>
                    </div>
                    <div class="mt-4">
                        <div class="row">
                            <div class="col-sm-6 text-sm-left text-center">
                                <h6 class="green-color text-uppercase">Visit Our Office</h6>
                                <h3 class="text-dark res-h3-small">
                                    <a class="text-dark" href="https://www.google.com/maps" target="_blank">
                                        Laredo, TX 78041, USA
                                    </a>
                                </h3>
                            </div>
                            <div class="col-sm-6 mt-sm-0 mt-4 text-sm-left text-center">
                                <h6 class="green-color text-uppercase">Or Send Mail Us</h6>
                                <h3 class="text-dark res-h3-small">
                                    <a href="mailto:contact@cynexsol.com" class="text-dark">
                                        contact@cynexsol.com
                                    </a>,
                                    <br>
                                    <a href="tel:+19562821034" class="text-dark">+1 (956) 282-1034</a>
                                </h3>
                            </div>
                        </div>
                    </div>
                    <form @submit.prevent="submitForm" class="common-input-form mt-3">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input v-model="form.name" name="name" id="name" type="text" class="form-control border-0" placeholder="Your Name" required>
                                </div>
                                <div class="form-group">
                                    <input v-model="form.email" name="email" id="email" type="email" class="form-control border-0" placeholder="Your Email" required>
                                </div>
                                <div class="form-group">
                                    <input v-model="form.subject" name="subject" id="subject" type="text" class="form-control border-0" placeholder="Subject" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <textarea v-model="form.comments" name="comments" id="comments" rows="2" class="form-control border-0" placeholder="Message" required></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="submit" class="mt-2 btn theme-btn contact-form-btn border-0">Send</button>
                        </div>
                    </form>
                    <div v-if="responseMessage" :class="responseStatus" class="mt-3">
                        {{ responseMessage }}
                    </div>
                </div>
            </div>
        </section>
        <!-- Contact Section End-->
    </div>
</template>
<script>
    //WOW JS
    import { WOW } from 'wowjs';
    export default {
        name: 'contact',
        mounted() {
            this.init();
        },
        data() {
            return {
                form: {
                    name: "",
                    email: "",
                    subject: "",
                    comments: "",
                },
                responseMessage: "",
                responseStatus: "",
            };
        },
        methods: {
            async submitForm() {
                try {
                    const response = await fetch("https://formspree.io/f/xdkgdrnb", {
                        method: "POST",
                        headers: { 
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        },
                        body: JSON.stringify(this.form),
                    });

                    if (!response.ok) {
                        throw new Error("Failed to send message.");
                    }

                    this.responseMessage = "Message sent!";
                    this.responseStatus = "text-success";
                    this.resetForm();
                    this.autoHideMessage();
                } catch (err) {
                    console.error(err);
                    this.responseMessage = "Failed to send message.";
                    this.responseStatus = "text-danger";
                    this.autoHideMessage();
                }
            },
            resetForm() {
                this.form = {
                    name: "",
                    email: "",
                    subject: "",
                    comments: "",
                };
            },
            autoHideMessage() {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }
                this.timeoutId = setTimeout(() => {
                    this.responseMessage = "";
                    this.responseStatus = "";
                }, 5000);
            },
            init() {
                this.initWowAnimation();              
            },
            /*----WOW ANIMATION-----*/
            initWowAnimation() {
                var length = $('.wow').length;
                if (length >= 1) {
                    const wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: 0,
                    });
                    wow.init();
                }
            } 
        }
    }
</script>